import "./modules.css";
import { nounUpload } from "helper/images";
import Loader from "shared/Components/loader";


export const Button = ({
	label,
	onClick,
	width = "w-40",
	disabled = false,
	icon,
  }) => {
	const isCancel = label === "Cancel";
	const buttonClass = `font-inter text-sm leading-5 h-11 font-semibold ${
	  isCancel
		? "hover:bg-gray-300 text-gray-600 rounded-md"
		: "text-white bg-primary hover:bg-purple-800"
	} ${width} ${disabled ? "opacity-50" : ""} rounded-lg items-center justify-center flex`;

	const labelClass = `${width} font-inter text-sm leading-5 h-11 font-semibold ${
	  isCancel
		? "border border-gray-300 rounded-md"
		: "text-white"
	}  flex flex-row justify-center items-center`;

	return (
	  <div className={buttonClass} style={{ margin: "8px auto" }}>
		<button onClick={onClick} className={labelClass} disabled={disabled}>
		  {disabled ? (
			<Loader stroke="text-[#fff]" />
		  ) : (
			<>
			  {label} {icon && <img src={nounUpload} alt="upload" className="w-6 ml-2" />}
			</>
		  )}
		</button>
	  </div>
	);
  };
  